var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { actionStyle } from "./InsertRow";
import TableCell from "@mui/material/TableCell";
import { EditCell } from "./EditCell";
import { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import { useAsyncAction } from "nate-react-api-helpers";
import { showSnack } from "../../TSnackbar";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ checkboxPadding: { padding: "0 12px 0 16px", "& .MuiCheckbox-root": { padding: 0 } } }); });
export function Cell(props) { var c = props.column; var row = props.row; var styles = useStyles().classes; if (c.actions) {
    var style = c.width ? Object.assign({}, actionStyle, { width: c.width }) : actionStyle;
    return /*#__PURE__*/ _jsx(TableCell, { className: styles.checkboxPadding, style: style, children: c.selector(row) }, "actions");
} return /*#__PURE__*/ _jsx(EditCell, { locked: props.locked || c.editable === false || c.type === "computed", onChange: props.onChange, row: row, value: valueSelector(c, row), column: c, index: props.index, rowId: row.id }, c.name); }
export function useEditRowHelpers(props) {
    var _this = this;
    var row = props.row;
    var onRowChange = props.onRowChange;
    var update = useAsyncAction(function (p) { return __awaiter(_this, void 0, void 0, function () { var result, e_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, props.updateServer(p.newValue)];
            case 1:
                result = _a.sent();
                props.onRowChange(result);
                showSnack("Row updated!", { variant: "success" });
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                props.onRowChange(p.old);
                showSnack(e_1.message, { variant: "error" });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); }, [props.updateServer, props.onRowChange]);
    var updater = update.callback;
    return useCallback(function (cb) {
        var updated = cb(row);
        if (updated === undefined)
            return;
        if (shallowEquals(updated, row)) {
            return; // no changes
        }
        updater({ old: row, newValue: updated });
        onRowChange(updated);
    }, [row, updater, onRowChange]);
}
function valueSelector(c, row) { if (!c.key) {
    if (c.type === "computed")
        return c.selector(row);
    return "";
} if (c.type === "computed")
    return c.selector(row); var v = row[c.key]; if (v === undefined)
    return ""; return v; }
function shallowEquals(a, b) { for (var i in a) {
    if (a[i] !== b[i])
        return false;
} return true; }
